export enum ProfileStatus {
    Active,
    Deactivated
}